var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Import(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.91 36v4h-35v10L20 38l12.91-12v10h35zm-18.5 17.91a22.333 22.333 0 01-7.15 4.82 22.65 22.65 0 01-17.52 0 22.51 22.51 0 010-41.46 22.65 22.65 0 0117.52 0 22.57 22.57 0 0112 12l3.69-1.56a26.47 26.47 0 100 20.64l-3.69-1.56a22.33 22.33 0 01-4.85 7.12z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Import.d8af16df.svg";
export { SvgJ2Import as ReactComponent };